import { render, staticRenderFns } from "./LLMBenchmark.vue?vue&type=template&id=631236f3&scoped=true&lang=pug&"
import script from "./LLMBenchmark.vue?vue&type=script&lang=js&"
export * from "./LLMBenchmark.vue?vue&type=script&lang=js&"
import style0 from "./LLMBenchmark.vue?vue&type=style&index=0&id=631236f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631236f3",
  null
  
)

export default component.exports